import React from "react";
import Home from "./pages/Home";
import Objetivos from "./pages/Objetivos";
import Ods from "./pages/Ods";
import Importancia from "./pages/Importancia";
import "./pages/Home.css";

function App() {
  return (
    <>
      <Home />
      <Objetivos />
      <Ods />
      <Importancia />
    </>
  );
}

export default App;
